import { render } from "./Logo.vue?vue&type=template&id=41a33c3a&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=41a33c3a&scoped=true&lang=css"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a33c3a"]])

export default __exports__